var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatbubbleUnread = function SvgChatbubbleUnread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1 3.4c0-.9.3-1.7.8-2.3-1.2-.4-2.5-.6-4-.6C4.5.4 0 4 0 8.4s4.5 8 10 8c.9 0 1.8-.1 2.7-.3.2-.1.5 0 .7.1l5.2 2.7c.4.2.8-.1.7-.6l-1.1-4.7c-.1-.3 0-.6.2-.9 1-1.2 1.6-2.7 1.6-4.3 0-1-.2-1.9-.6-2.8-.7.8-1.6 1.3-2.7 1.3-2 0-3.6-1.6-3.6-3.5zm3.6 1.8c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8 1.8.8 1.8 1.8 1.8z"
  })));
};
export default SvgChatbubbleUnread;